import { makeRequestGet, makeRequestGet2, makeRequestPut2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getManagers() {
  let token = await getToken();
  return makeRequestGet2(`managers/`, token);
}

export async function getManager(id) {
  let token = await getToken();
  return makeRequestGet2(`managers/${id}`, token);
}

export async function putManager(id, data) {
  let token = await getToken();
  return makeRequestPut2(`managers/${id}`, data, token);
}
